module.exports = __webpack_public_path__ + "img/wddb-menu.fc13bcd7.png";